import { render } from "./TypeAheadComponent.vue?vue&type=template&id=8ada63e4&scoped=true"
import script from "./TypeAheadComponent.vue?vue&type=script&lang=js"
export * from "./TypeAheadComponent.vue?vue&type=script&lang=js"

import "./TypeAheadComponent.vue?vue&type=style&index=0&id=8ada63e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ada63e4"]])

export default __exports__